/* Stylesheet */

.searchbar {
  display: flex;
  position: absolute;
  left: 0;
  align-items: center;
  height: 100%;
  width: 100%;
  background: #f2f5fa;
  z-index: 100;

  .input {
    --padding-start: 21px;
  }
}
